export const delay = (timeout = 100) =>
  new Promise((res) => setTimeout(res, timeout));
